module.exports = __webpack_public_path__ + "static/media/error.b1482f59.svg";